import { DEFAULT_LANGUAGE, LOCALES } from '@constants';
import { format } from 'date-fns';
import { tz } from '@date-fns/tz';

type Options = {
  timezone?: string | null;
  language?: string | null;
  showTimezone?: boolean;
  showDate?: boolean;
  showTime?: boolean;
  showSeconds?: boolean;
  format?: string;
  includeDateComma?: boolean;
};

const getFormatString = ({
  showDate = true,
  includeDateComma = true,
  showTime = true,
  showSeconds = true,
  showTimezone = false,
  language = DEFAULT_LANGUAGE,
}: Options) => {
  if (showDate && showTime) {
    if (language === 'pt') {
      return `d MMM yyyy H:mm${showSeconds ? ':ss' : ''}${showTimezone ? ' zzz' : ''}`;
    }
    return `d MMM yyyy h:mm${showSeconds ? ':ss' : ''} ${language === 'es' ? 'aaa' : 'aa'}${
      showTimezone ? ' zzz' : ''
    }`;
  }

  if (showDate) {
    return includeDateComma ? 'MMM d, yyyy' : 'MMM d yyyy';
  }

  if (showTime) {
    if (language === 'pt') {
      return `H:mm${showSeconds ? ':ss' : ''}${showTimezone ? ' zzz' : ''}`;
    }
    return `h:mm${showSeconds ? ':ss' : ''} ${language === 'es' ? 'aaa' : 'aa'}${
      showTimezone ? ' zzz' : ''
    }`;
  }

  return '';
};

export default (date: string | Date, options?: Options) => {
  if (!date) return '';

  const formatStr = options?.format || getFormatString(options ?? {});
  const parsedDate = new Date(date);
  const locale = LOCALES[(options?.language || DEFAULT_LANGUAGE) as keyof typeof LOCALES];

  return format(parsedDate, formatStr, {
    locale,
    ...(options?.timezone && {
      in: tz(options.timezone),
    }),
  }).replace(/[a-zA-Z]/, (l) => (options?.showDate !== false ? l.toUpperCase() : l));
};
